import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  GlobalSearchParams,
  SEARCH_PARAM_ORG_ID,
} from 'routes/(global_search_params)/-searchParams'
import { createVirtualReportsSearch } from 'routes/virtual-reports/-searchParams'
import { Route as NewRoute } from 'routes/virtual-reports/index'

export const Route = createFileRoute(
  '/virtual-reports/(deprecated_routes)/$siteID/'
)({
  beforeLoad: ({ params }) => {
    const siteId = params.siteID

    throw redirect({
      to: NewRoute.to,
      search: (prev: Record<string, unknown> & GlobalSearchParams) => ({
        ...prev,
        ...createVirtualReportsSearch({
          orgId: prev[SEARCH_PARAM_ORG_ID],
          siteId,
        }),
      }),
      replace: true,
    })
  },
})
